/**
 * @description:
 * @author: Rian
 * @date: 2022-05-10 11:27:22
**/

const baseSize = 16;

function setRem() {
  // 当前页面宽度相对于 1920宽的缩放比例，可根据自己需要修改。
  const scale = document.documentElement.clientWidth / 1920;
  let w =  baseSize * Math.min(scale, 2);
  if(w<14){
    w=14;
  }
  // 设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2）
  document.documentElement.style.fontSize = w + 'px';
  document.documentElement.style.widows = baseSize * Math.min(scale, 2)+ 'px';
}
setRem()
window.onresize = function () {
  setRem()
}
